
import { Component, Emit, Mixins, Prop, Watch } from 'vue-property-decorator';
import Vue from 'vue';
@Component({
    components: {
       
    }
})
export default class AddPolygon extends Vue {
    @Prop({ default: false }) visible: boolean;
    @Prop({ default: false }) editing: boolean;
    @Prop({ default: '' }) polyName: string;
    @Prop({ default: 'Modificar ' }) modalTitle: string;
    @Prop({ default: false }) deleteMode: boolean;
    @Prop({ default: 0 }) selectedPolygonsCount: number;
    cropTypeOptions: Array<object> = [];
    loading: boolean = false;
    name: string = '';

    @Emit()
    clickAddNewPolygon() {}

    @Emit()
    modifyRanchPolygon(name: string) {}

    @Emit()
    savePolygon(name: string) {
        this.modifyRanchPolygon(this.polyName)
    }

    @Emit()
    cancelPolygon() {}

    @Emit()
    enterDeleteMode() {}

    @Emit()
    exitDeleteMode() {}

    @Emit()
    confirmDeletePolygons() {}

    @Emit()
    confirmKeepOnlySelected() {}

    mounted() {
        
    }
}
